const Vue = require('vue')

const parse = (v) => {
    return !!v
}

Vue.component('form-new-check', {
    props: {
        label: {
            type: String
        },
        model: {
            twoWay: true,
            default: null
        },
        compact: {
            default: false
        },
        onChange: {
            type: Function,
            default: () => {
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: null
        },
        willChange: {
            type: Function,
            default: (value, done) => done(value)
        }
    },
    data () {
        return {
            fieldName: '',
            hovered: false,
            block: false
        }
    },
    ready () {
        this.fieldName = this.name || this._props.model.raw
    },
    methods: {
        changed (evt) {
            if (this.onChange) {
                this.onChange(evt.target.checked)
            }
        },

        toggle () {
            if (this.block) {
                return
            }
            this.block = true
            const newValue = !this.model
            this.willChange(newValue, (update) => {
                this.model = update

                this.block = false
            })
        },

        showTooltip () {
            this.hovered = true
        },

        hideTooltip () {
            this.hovered = false
        }
    },
    computed: {
        text () {
            if (this.model) {
                return '<i class="fa fa-check" style="display: block"></i>'
            }

            return '&nbsp;'
        },
        tooltip () {
            if (this.model) {
                return 'Sim'
            }

            return 'Não'
        }
    },
    watch: {},
    template: `
            <div class="form-group nullable-check-holder" style="position: relative">
                <label style="margin: 0">
                    <button type="button" class="nullable-check" :class="checkClass" @click.prevent="toggle()" :disabled="block">
                        {{{ text }}}
                    </button>
                    <slot name="label">
                        {{{ label }}}
                    </slot>                    
                </label>
                <form-errors :fields="[fieldName]"></form-errors>
            </div>
        `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/new-check.js